/* eslint-disable react/no-unknown-property */
import React, { Suspense } from 'react';

import { Box, Button, Grid, Stack, Typography } from '@mui/material';
import { useGLTF } from '@react-three/drei';
import { Canvas } from '@react-three/fiber';
import { ButtonWithIcon } from 'src/v2/components/ui/buttons/buttonWithIcon';
import { GenericInfoLabel } from 'src/v2/components/ui/label';

import { useAllVaultData } from '~components/hooks/protocol/vaults/useAllVaultData';
import { useIsMobile } from '~components/hooks/utils/useIsMobile';
import { primaryColors } from '~components/theme/styles/colors';
import { EDisplayType } from '~components/types';
import { displayFormatUnits } from '~components/utils/utils';

import SlideWrapper from '../SlideWrapper';

const MODEL_MASK_PATH = '/models/Mecha_Helmet.gltf';

// const VestaMaskModelScene: FC<{ mouseX: number; mouseY: number }> = ({ mouseX, mouseY }) => {
//   const { scene } = useGLTF(MODEL_MASK_PATH);
//   const frontFaceSpot = React.useRef<PointLight>(null!);
//   const modelRef = React.useRef<Object3D>(null!);

//   useThree(({ camera }) => {
//     camera.position.set(-0.2, 0.3, 1);
//     if (modelRef.current) {
//       modelRef.current.lookAt(mouseX / 3500, -mouseY / 3500, 1);
//     }
//   });

//   return (
//     <>
//       <ambientLight />
//       <spotLight color={[0.75, 0.5, 0.8]} intensity={10} position={[0, 10, 45]} />

//       <pointLight ref={frontFaceSpot} color={[0.75, 1, 1]} intensity={10} position={[-2, 3.5, 3.5]} />
//       <primitive ref={modelRef} object={scene} />
//     </>
//   );
// };

useGLTF.preload(MODEL_MASK_PATH);

function LandingSlide() {
  const {
    computed: { totalCollateralUsd, totalSystemDebtVst },
  } = useAllVaultData();

  // const [mouseX, setMouseX] = useState<number>(0);
  // const [mouseY, setMouseY] = useState<number>(0);

  const isMobile = useIsMobile();

  return (
    <SlideWrapper
      onMouseMove={e => {
        // setMouseX(e.clientX - window.innerWidth / 0.8);
        // setMouseY(e.clientY - window.innerHeight / 1.3);
      }}
      sx={{
        justifyContent: 'center',
        overflow: 'hidden',
      }}
    >
      {!isMobile ? (
        <Box sx={{ position: 'absolute', top: 16, right: 0, width: 800, height: { xs: 1080, md: 1200 } }}>
          <Suspense fallback={null}>
            <Canvas>{/* <VestaMaskModelScene mouseX={mouseX} mouseY={mouseY} /> */}</Canvas>
          </Suspense>
        </Box>
      ) : null}
      <Stack mt={28} justifyContent={{ xs: 'center', sm: 'start' }} textAlign={{ xs: 'center', sm: 'left' }}>
        <Grid item xs={12} sm={6}>
          <Typography variant={'h2'}>Uncensorable, yield generating stablecoin</Typography>
          <Typography variant={'body1'} mt={4} mb={8} color={primaryColors[400]}>
            Vesta Stable (VST) is a non-biased, non-censorable stablecoin that can be generated against crypto
            asset and used anywhere, anytime.
          </Typography>
          <Stack direction={{ xs: 'column', sm: 'row' }} textAlign={{ xs: 'center', sm: 'left' }} spacing={2}>
            <ButtonWithIcon sx={{ width: { xs: '100%', sm: 300 } }} variant={'primary'} iconType="arrow">
              {' '}
              ENTER THE APPLICATION
            </ButtonWithIcon>
            <Button variant={'secondary'} sx={{ width: { xs: '100%', sm: 300 } }}>
              {' '}
              HOW IT WORKS{' '}
            </Button>
          </Stack>
        </Grid>
        <Box mt={{ xs: 32, md: 20 }}>
          <GenericInfoLabel
            variant="vertical"
            labelTitleVariant={'h6'}
            labelTitle={'Total Value Locked'}
            labelValueVariant={'h2'}
            labelValue={displayFormatUnits({ value: totalCollateralUsd, displayType: EDisplayType.USD })}
          />
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 4, sm: 0 }}
            mt={8}
            justifyContent={'space-between'}
          >
            <GenericInfoLabel
              variant="vertical"
              labelTitleVariant={'h6'}
              labelTitle={'Total Volume of VST Traded'}
              labelValueVariant={'h4'}
              labelValue={displayFormatUnits({ value: 1000000, displayType: EDisplayType.USD })}
            />
            <GenericInfoLabel
              variant="vertical"
              labelTitleVariant={'h6'}
              labelTitle={'Total VST Circulating'}
              labelValueVariant={'h4'}
              labelValue={displayFormatUnits({ value: totalSystemDebtVst, displayType: EDisplayType.VST })}
            />
            <GenericInfoLabel
              variant="vertical"
              labelTitleVariant={'h6'}
              labelTitle={'Vaults Opened'}
              labelValueVariant={'h4'}
              labelValue={42069}
            />
          </Stack>
        </Box>
      </Stack>
    </SlideWrapper>
  );
}

export default LandingSlide;
